import { Injectable, inject, signal } from '@angular/core';
import { ErrorService } from './error.service';
import { Storage } from '@ionic/storage-angular';

@Injectable({
  providedIn: 'root',
})
export class SettingsService {
  private errorService = inject(ErrorService);

  private _darkMode = signal<boolean>(false);
  private _showNextWorkOrder = signal<boolean>(false);
  private _userSignature = signal<string | null>(null);
  private storage = inject(Storage);

  darkMode = this._darkMode.asReadonly();
  showNextWorkOrder = this._showNextWorkOrder.asReadonly();
  userSignature = this._userSignature.asReadonly();
  constructor() {
  }

  async init() {
    this._darkMode.set(await this.storage.get('dark-mode'));
    if (this._darkMode()) {
      document.documentElement.classList.add('ion-palette-dark');
    }
    const show = await this.storage.get('show-next-work-order');
    this._showNextWorkOrder.set(show !== null && show !== undefined ? show : false);
    this._userSignature.set(await this.storage.get('user-signature') ?? null);
  }

  async setDarkMode(darkMode: boolean): Promise<void> {
    await this.storage.set('dark-mode', darkMode);
    this._darkMode.set(darkMode);
    if (darkMode) {
      document.documentElement.classList.add('ion-palette-dark');
    } else {
      document.documentElement.classList.remove('ion-palette-dark');
    }
  }

  async setShowNextWorkOrder(showNextWorkOrder: boolean): Promise<void> {
    await this.storage.set('show-next-work-order', showNextWorkOrder);
    this._showNextWorkOrder.set(showNextWorkOrder);
  }

  async setUserSignature(svg: string | null): Promise<void> {
    if (svg) {
      await this.storage.set('user-signature', svg);
    } else {
      await this.storage.remove('user-signature');
    }
    this._userSignature.set(svg);
  }
}
